import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getDetailCompanyFinancialStatus = createAsyncThunk('/dashboard_detail_company_financial_status/content', async (id) => {
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/detailCompanyFinancialStatusDash/${id}`, {})
    return response.data;
})

export const dashboardDetailCompanyFinancialStatusSlice = createSlice({
    name: 'dashboard_detail_company_financial_status',
    initialState: {
        isLoading: false,
        dashboard_detail_company_financial_status: []
    },

    /*extraReducers: {
        [getDetailCompanyFinancialStatus.pending]: state => {
            state.isLoading = true
        },
        [getDetailCompanyFinancialStatus.fulfilled]: (state, action) => {
            state.dashboard_detail_company_financial_status = action.payload.data
            state.isLoading = false
        },
        [getDetailCompanyFinancialStatus.rejected]: state => {
            state.isLoading = false
        },
    }*/
    extraReducers: (builder) => {
        builder
            .addCase(getDetailCompanyFinancialStatus.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getDetailCompanyFinancialStatus.fulfilled, (state, action) => {
                state.dashboard_detail_company_financial_status = action.payload.data;
                state.isLoading = false;
            })
            .addCase(getDetailCompanyFinancialStatus.rejected, (state) => {
                state.isLoading = false;
            });
    }
})

export default dashboardDetailCompanyFinancialStatusSlice.reducer